import { PROCESS } from "@/lib/content";
import { Reveal, Overline } from "@/components/site/Reveal";

export default function Process() {
  return (
    <section id="process" data-testid="process-section" className="bg-[#F8FAFC] py-24 md:py-32">
      <div className="mx-auto max-w-[1400px] px-6 md:px-12">
        <div className="mb-16 max-w-2xl">
          <Reveal>
            <Overline>How We Work</Overline>
          </Reveal>
          <Reveal delay={0.1}>
            <h2 className="mt-5 font-display text-4xl font-bold leading-[1.02] tracking-tighter text-[#0B3A82] sm:text-5xl md:text-6xl">
              A precise process, six steps up.
            </h2>
          </Reveal>
        </div>

        <div className="border-t border-[#0B3A82]/15">
          {PROCESS.map((p, i) => (
            <Reveal key={p.n} delay={0.05}>
              <div
                data-testid={`process-step-${i}`}
                className="group grid grid-cols-1 items-start gap-4 border-b border-[#0B3A82]/15 py-8 transition-colors hover:bg-white md:grid-cols-[200px_1fr_auto] md:gap-8 md:py-10"
              >
                <span className="font-display text-6xl font-bold leading-none tracking-tighter text-outline-blue transition-all duration-500 group-hover:text-[#D89A18] md:text-8xl">
                  {p.n}
                </span>
                <div className="md:pt-3">
                  <h3 className="font-display text-2xl font-bold tracking-tight text-[#0B3A82] md:text-3xl">
                    {p.title}
                  </h3>
                  <p className="mt-2 max-w-xl font-body text-base leading-relaxed text-[#475569]">
                    {p.desc}
                  </p>
                </div>
                <div className="hidden h-2 w-2 self-center bg-[#D89A18] opacity-0 transition-opacity duration-500 group-hover:opacity-100 md:block" />
              </div>
            </Reveal>
          ))}
        </div>
      </div>
    </section>
  );
}
